<button
  class="help-fab"
  [class.help-fab--inline]="inline"
  [class.help-fab--left]="drawerOpen"
  [matTooltip]="tooltip"
  [matTooltipPosition]="inline ? 'above' : drawerOpen ? 'right' : 'left'"
  (click)="openHelp()"
  aria-label="Open user guide"
>
  <mat-icon class="material-symbols-outlined">help</mat-icon>
</button>
